import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { styled } from '@mui/material/styles';
import React from 'react';
import { getImageAssetUrl } from '../../../utils/assetUtils.js';
import { TABLET_SCREEN_SIZE, MOBILE_SCREEN_SIZE } from '../../../utils/constants/Constants.js';

var StyledDialogContent = styled('div')(function (_a) {
    var _b, _c, _d;
    var theme = _a.theme;
    return ({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'stretch',
        textAlign: 'center',
        margin: '0 auto',
        position: 'relative',
        width: 'fit-content',
        gap: 10,
        '.img_container': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: '0 auto',
        },
        '.logo': {
            width: 51,
            height: 51,
        },
        '.title': (_b = {
                color: "".concat(theme.palette.primary.main, " !important"),
                marginTop: 10,
                marginBottom: 10,
                fontSize: 24,
                fontWeight: 'bold'
            },
            _b["@media (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                fontSize: 22,
            },
            _b["@media (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
                fontSize: 22,
            },
            _b),
        '.second-title': (_c = {
                color: "".concat(theme.palette.primary.main, " !important"),
                fontSize: 20,
                fontWeight: 600
            },
            _c["@media (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                fontSize: 18,
                fontWeight: 600,
            },
            _c["@media (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
                fontSize: 18,
                fontWeight: 600,
            },
            _c),
        '.subtitle': (_d = {
                color: "".concat(theme.palette.primary.main, " !important"),
                fontSize: 18,
                fontWeight: 500,
                maxWidth: 380
            },
            _d["@media (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                fontSize: 14,
            },
            _d["@media (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
                fontSize: 14,
            },
            _d),
        '.phone-input-container': {
            margin: '12px auto',
            'div:first-of-type': {
                alignItems: 'center',
            },
        },
        '.arrow-text': {
            justifyContent: 'center',
        },
        '.video-container': {
            maxWidth: 314,
            maxHeight: 414,
        },
        '.share-container': {
            paddingTop: 10,
        },
    });
});
var ProductPageDialogContent = function (_a) {
    var imageUrl = _a.imageUrl, _b = _a.imageSize, imageSize = _b === void 0 ? 51 : _b, showIcon = _a.showIcon, title = _a.title, secondTitle = _a.secondTitle, subtitle = _a.subtitle, children = _a.children, props = __rest(_a, ["imageUrl", "imageSize", "showIcon", "title", "secondTitle", "subtitle", "children"]);
    return (React.createElement(StyledDialogContent, { className: "styled-dialog-content", sx: __assign({ paddingBottom: '55px' }, props.sx) },
        imageUrl && (React.createElement("div", { className: "img_container" },
            React.createElement("img", { loading: "lazy", src: imageUrl, alt: "", style: { width: imageSize, height: imageSize, objectFit: 'contain' } }))),
        showIcon && (React.createElement("div", null,
            React.createElement("img", __assign({ loading: "lazy", src: getImageAssetUrl('brandclub-b-logo.webp'), alt: "", className: "logo" }, props.iconProps)))),
        title && React.createElement("div", { className: "title" }, title),
        secondTitle && React.createElement("div", { className: "second-title" }, secondTitle),
        subtitle && React.createElement("div", { className: "subtitle" }, subtitle),
        children));
};

export { ProductPageDialogContent, StyledDialogContent };
//# sourceMappingURL=ProductPageDialogContent.js.map
